(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   **/
  var initLeftNavMenu = function () {
    var self = this;
    var $menu = $(self).find('.menu-contact-wrapper');
    var $mobileButton = $(self).find('.icon-wrapper');
    var $submenu = $(self).find('.submenu');
    var $expandedAttr = $('.mc--left-nav [aria-expanded]');

    $mobileButton.click(function (e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $menu.slideToggle();
    });

    $.mediaquery('bind', 'mobileLeftNavMenu', '(max-width: 767px)', {
      leave: function () {
        $menu[0].removeAttribute('style');
      }
    });

    $.mediaquery('bind', 'mobileLeftNavMenu', '(max-width: 1024px)', {
      leave: function () {
        $submenu.removeAttr('aria-hidden');
      }
    });

    if ($expandedAttr.length) {
      $expandedAttr.removeAttr('aria-expanded');
      $expandedAttr.removeAttr('aria-haspopup');
    }
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   **/
  window.DP.behaviors.leftNavPageMenu = {
    attach: function (context) {
      once('leftNavPageMenu', '.cc--left-navigation-menu', context)
        .forEach((e) => {
          initLeftNavMenu.apply(e);
        });
      // $(context).find('.cc--left-navigation-menu').once('leftNavPageMenu').each(function () {
      //   initLeftNavMenu.apply(this);
      // });
    }
  };

}(jQuery));
